// test663
(663 && 0);
